import React from 'react';

import styles from './RightSidebar.module.css';

const RightSidebar = props => {
  return <div className={`${styles.sidebar}`}>{props.children}</div>;
};

export default RightSidebar;
